module.exports = __webpack_public_path__ + "static/img/fmce-logo.0dd9626.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fmce-logo.png
// module id = IteF
// module chunks = 1